import ModalEventBus from 'components/Modal/ModalEventBus';

import Vue from 'vue';
import store from 'client/store';

const ContactSupportMainPanel = () => import('client/Support/ContactSupportMainPanel.vue');
const SubmitIdeaModal = () => import('client/Support/SubmitIdeaModal.vue');

export default [
  {
    path: '/support',
    name: 'Support',
    beforeEnter(to, from, next) {
      store.commit('SupportModule/SET_SUPPORT_OVERLAY_OPEN', true);
      return next('/home');
    },
  },
  {
    path: '/support/contact',
    name: 'Contact Support',
    meta: {
      title: 'Support',
    },
    components: {
      mainPanel: ContactSupportMainPanel,
    },
  },

  {
    path: '/support/submit-idea',
    name: 'SubmitIdea',
    async beforeEnter(to, from, next) {
      next('/home');

      // When this route hook executes in a New Tab, the app hasn't mounted yet, and TheModal
      // is not yet listening for ModalEventBus events
      await Vue.nextTick();

      ModalEventBus.open({
        component: SubmitIdeaModal,
        isLargeModal: true,
      });
    },
  },

  {
    path: '/support/case-portal',
    name: 'CasePortal',
    meta: {
      title: 'Case Portal',
    },
    components: {
      mainPanel: () => import('client/Support/CasePortal/CasePortal.vue'),
    },
  },
];
